export enum TextCustomizationVariantsEnum {
  LIGHT = 'light',
  DARK = 'dark',
}
